import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {withRouter} from "react-router-dom";
import oitsActionCreators from "../../store/oits/action-creators/oits";
import LoadingOverlay from "../../../shared/components/LoadingOverlay";
import {Input} from "reactstrap";
import {ApiGet} from "../../../shared/services/api-service";
import {normalizeOitReport} from "../../services/analytics";
import './OitAnalytics.scss';
import Modal from "../../../shared/ui/Modal";
import ReportView from "../reports/ReportView";
import reportsActionCreators from "../../store/reports/action-creators";
import Checkbox from "../../../shared/forms/Checkbox";
import AnalyticsReport from "./AnalyticsReport";
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import userContext from "../../models/userContext";
import OitRatingStatistics from "./OitRatingStatistics";
import LogAnalytics from "./LogAnalytics";
import myTrainingProgramActionCreators from "../../store/my-training-program/action-creators";

class OitAnalytics extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedOit: '',
      compareOit: '',
      reportAnalytics: [],
      selectedQuestions: {},
      selectedQuestionIds: {},
      selectedReport: 'rating',
      showQuestionsModal: false,
      showFormTypeModal: false,
      selectAll: true,
      deselectAll: false,
      mapWeeksToPhaseStart: false,
      showAllOits: false,
      selectedFormTypes: ['dor', 'dor2', 'dor3', 'dor3', 'rdor','wor','dorr'],
      shownReports: {
        statistics: false,
        analytics: true
      },

      selectedPhasesMap: {}
    };
  }

  componentDidMount() {
    if(this.props.userContext.hasScope('oit')) {
      this.props.loadMyTrainingProgram()
        .then(() => {
          this.setSelectedOit(this.props.userContext.userGuid)
        });
    } else {
      this.props.loadOitsContainer(this.props.userContext.scope, 'active')
        .then(() => {
          if (this.oitsInProgress.length === 1) {
            this.setSelectedOit(this.oitsInProgress[0].guid);
          }
        });
    }
  }

  setSelectedOit(oitGuid) {

    if (this.state.reportAnalytics.find((ra) => ra.oitGuid === oitGuid)) {
      return
    }

    let oit = this.getOit(oitGuid);

    if(!this.state.reportAnalytics.length) {
      this.setState({
        selectedPhasesMap: ( oit.trainingPhases || this.props.myTrainingProgram.oit.trainingPhases)
          .filter(tp => tp.type !== 'orientation')
          .reduce((acc, tp) => ({
            ...acc,
            [tp.sequence]: true
          }), {})
      })
    }

    this.setState({
      selectedOit: oitGuid,
      isLoading: true
    });
    this.props.setIsViewingReport(null);

    ApiGet(`/api/v1/oits/${oitGuid}/training-phase-analytics/${this.state.selectedFormTypes.join(',')}`)
      .then((res) => {
        const reportAnalytics = normalizeOitReport(res, this.state.mapWeeksToPhaseStart);

        this.setState({
          isLoading: false,
          reportAnalytics: [...this.state.reportAnalytics, {
            raw: res,
            reportAnalytics,
            oitGuid,
            user: oit
          }],
          selectedQuestions: this.addQuestionsToFilter(reportAnalytics.questions),
          selectedQuestionIds: {
            ...this.state.selectedQuestionIds,
            ...reportAnalytics.questionsMapById
          },
        });
      })
  }

  reloadAnalytics() {
    let reportAnalytics = this.state.reportAnalytics;
    this.setState({
      reportAnalytics: [],
      isLoading: true
    }, () =>  {
      Promise.all(reportAnalytics.map(ra => ApiGet(`/api/v1/oits/${ra.oitGuid}/training-phase-analytics/${this.state.selectedFormTypes.join(',')}`)
        .then((res) => {
          const reportAnalytics = normalizeOitReport(res, this.state.mapWeeksToPhaseStart);

          this.setState({
            isLoading: false,
            reportAnalytics: [...this.state.reportAnalytics, {
              raw: res,
              reportAnalytics,
              oitGuid: ra.oitGuid,
              user: this.getOit(ra.oitGuid)
            }],
            selectedQuestions: this.addQuestionsToFilter(reportAnalytics.questions),
            selectedQuestionIds: {
              ...this.state.selectedQuestionIds,
              ...reportAnalytics.questionsMapById
            },
          });
        })))
    })
  }

  applyChanges() {
    this.setState({
      showFormTypeModal: false
    })
    this.reloadAnalytics()
  }

  isTrainingCompleted(trainingTracker, trainingPhases) {
    return (trainingTracker
        && trainingTracker.status === 'closed')
      || (trainingPhases.length > 0 && trainingPhases.filter((phase) => phase.status === 'completed').length === trainingPhases.length)
  }
  filterOit(oit) {
    return (
      !oit.trainingTracker || oit.trainingTracker.status === 'opened' || oit.trainingTracker.status === 'paused' || !oit.trainingTracker.status
    ) && !this.isTrainingCompleted(oit.trainingTracker, oit.trainingPhases);
  }

  get oitsInProgress() {
    if (this.state.showAllOits) {
      return this.props.oits
    }
    return this.props.oits
      && this.props.oits.filter(this.filterOit.bind(this))
  }

  get currentForms() {
    if(!this.props.forms) {
      return []
    }

    return this.props.forms
        .filter(f => f.status === 'current')
      .filter(f => {
        if (this.critiqueFormTypes.includes(f.type)) {
          return this.props.canViewCritiqueForms;
        }
        return true
      })
  }

  get critiqueFormTypes() {
    return this.props.departmentSettings && this.props.departmentSettings.critiqueFormTypes ? this.props.departmentSettings.critiqueFormTypes : ['ftc'];
  }

  setSelectedReport(report) {
    this.setState({
      selectedReport: report
    });
    this.props.setIsViewingReport(null);
  }

  setShowAllOits(e) {
    this.setState({
      showAllOits: e.target.checked
    })
    if(e.target.checked) {
      this.props.loadOitsContainer(this.props.userContext.scope, "all")
    }
  }

  removeOitReport(oitGuidForRemove) {
    if (this.state.reportAnalytics.length <= 1) {
      this.setState({
        selectedQuestions: {}
      })
    }

    this.setState({
      reportAnalytics: this.state.reportAnalytics.filter(({oitGuid}) => oitGuid !== oitGuidForRemove)
    })
  }

  handleFilterClick() {
    this.setState({
      showQuestionsModal: true
    });
  }

  handleFormTypeClick() {
    this.setState({
      showFormTypeModal: true
    });
  }

  closeQuestionsModal(e) {
    this.setState({
      showQuestionsModal: false
    });
  }

  closeFormTypeModal(e) {
    this.setState({
      showFormTypeModal: false
    });
  }

  onQuestionChange(value, fieldKey) {
    let selectedQuestions = this.state.selectedQuestions;
    selectedQuestions[fieldKey] = value

    this.setState({
      selectedQuestions: selectedQuestions,
      selectAll: false,
      deselectAll: false
    });

    this.filteredQuestions();
  }

  selectAllQuestions(value) {
    let questions = {};
    for (const property in this.state.selectedQuestions) {
      questions[property] = value;
    }

    this.setState({
      selectedQuestions: questions,
      selectAll: value,
      deselectAll: !value
    });
  }

  deselectAllQuestions(value) {
    let questions = {};
    for (const property in this.state.selectedQuestions) {
      questions[property] = !value;
    }

    this.setState({
      selectedQuestions: questions,
      selectAll: !value,
      deselectAll: value
    });
  }

  filteredQuestions() {
    return Object.keys(this.state.selectedQuestions).filter(question => this.state.selectedQuestions[question]);
  }

  getAllQuestions() {
    const that = this;
    let questions = {};


    this.state.reportAnalytics.reduce((acc, obj) => {
      obj.reportAnalytics.questions.reduce((acc, question) => {
        const questionStatus = that.state.selectedQuestions[question];
        questions[question] = questionStatus;

        return acc;
      }, {});

      return acc;
    }, {});


    return Object.keys(questions);
  }

  getOit(oitGuid) {
    if(this.props.userContext.hasScope('oit')) {
      return userContext(this.props.userContext)
    }
    return this.oitsInProgress.find(oit => oit.guid === oitGuid)
  }

  addQuestionsToFilter(questions) {
    return Object.assign(questions.reduce((acc, question) => ({
      ...acc,
      [question]: true
    }), {}), this.state.selectedQuestions)
  }

  addQuestionIdsToFilter(questions) {
    return Object.assign(questions.reduce((acc, question) => ({
      ...acc,
      [question.id]: true
    }), {}), this.state.selectedQuestionIds)
  }

  onOitRemoved(userId) {
    this.removeOitReport(userId);
  }

  onReportClick(data) {
    this.props.setIsViewingReport(data);
  }

  onMapWeeksToPhaseStartChange(checked) {
    this.setState({
      mapWeeksToPhaseStart: checked
    }, () => {
      this.recalculateReportAnalytics()
    });


  }

  onReportTypeChange(reportName, checked) {
    this.setState({
      shownReports: {
        ...this.state.shownReports,
        [reportName]: checked
      }
    });
  }

  recalculateReportAnalytics() {
    this.setState({
      reportAnalytics: this.state.reportAnalytics.map((ra) => ({
        ...ra,
        reportAnalytics: normalizeOitReport(ra.raw, this.state.mapWeeksToPhaseStart)
      }))
    })
  }

  isFormTypeChecked(form) {
    return this.state.selectedFormTypes.includes(form.type)
  }

  onFormTypeSelectChange(checked, form) {
    let selectedFormTypes = [...this.state.selectedFormTypes];
    if(checked) {
      selectedFormTypes = [...selectedFormTypes.filter(f => f !== form.type), form.type];
    } else {
      selectedFormTypes = selectedFormTypes.filter(f => f !== form.type);
    }

    this.setState({
      selectedFormTypes
    })
  }

  updateSelectedPhases(sequence, checked) {
    this.setState({
      selectedPhasesMap: {
        ...this.state.selectedPhasesMap,
        [sequence]: checked
      }
    })

  }

  get selectedOits() {
    return this.state.reportAnalytics.map(({oitGuid}) => this.getOit(oitGuid))
  }


  render() {
    return (
      <LoadingOverlay isLoading={this.state.isLoading}>
        <div className="app-content-header">
          <h4 className="title">Analytics</h4>
        </div>
        <div className="oit-analytics app-content">
          <div className="form">
            {!this.props.userContext.hasScope('oit') && <div>
              <Checkbox checked={this.state.showAllOits} onChange={(e) => this.setShowAllOits(e)}
                        label={'Show all ' + this.props.oitShortLabel + 's'}/>
            </div>}
            <div style={{display: 'flex'}}>
              <div className="mr-2">
                <button className="button secondary" onClick={() => this.handleFormTypeClick()}>
                  <i className="fa fa-paperclip"/>
                  Form types
                </button>
              </div>
              {!this.props.userContext.hasScope('oit') && <div className="form-group" style={{maxWidth: '50%'}}>
                <Input
                  name="type"
                  onChange={event =>
                    this.setSelectedOit(event.target.value)
                  }
                  type="select"
                  value={''}
                >
                  <option
                    defaultValue={''}>{this.state.reportAnalytics.length ? `Add ${this.props.oitShortLabel} to compare` : 'Select ' + this.props.oitShortLabel}</option>
                  {this.oitsInProgress && this.oitsInProgress.map(oit => (
                    <option key={oit.guid} value={oit.guid}>{oit.getFullName()}</option>
                  ))}
                </Input>
              </div>}
              {this.state.reportAnalytics.length > 0 && (
                <Fragment>
                  <div className="form-group type">
                    <Input
                      name="report-type"
                      onChange={event =>
                        this.setSelectedReport(event.target.value)
                      }
                      type="select"
                      value={this.state.selectedReport}
                    >
                      <option defaultValue={''}>Select Report Type</option>
                      <option value="rating">Rating report</option>
                      <option value="time-spend">Time spend report</option>
                    </Input>
                  </div>

                  <div className="ml-2">
                    <button className="button secondary" onClick={() => this.handleFilterClick()}>
                      <i className="fa fa-filter"/>
                      Filter questions
                    </button>
                  </div>
                </Fragment>
              )}
            </div>

            <Checkbox
              label={'Map weeks to phase starts'}
              onChange={(event) => this.onMapWeeksToPhaseStartChange(event.target.checked)}
              checked={this.state.mapWeeksToPhaseStart}/>

            <Checkbox
              label={'Show Statistics report'}
              onChange={(event) => this.onReportTypeChange('statistics', event.target.checked)}
              checked={this.state.shownReports.statistics}/>

            <Checkbox
              label={'Show log report'}
              onChange={(event) => this.onReportTypeChange('log', event.target.checked)}
              checked={this.state.shownReports.log}/>

            <Checkbox
              label={'Show Analytics report'}
              onChange={(event) => this.onReportTypeChange('analytics', event.target.checked)}
              checked={this.state.shownReports.analytics}/>

            {this.state.reportAnalytics.length && !this.props.userContext.hasScope('oit') ? (
              <div className="selected-users">
                <div style={{display: 'flex', flexWrap: 'wrap'}}>
                  {this.state.reportAnalytics[0].user.trainingPhases
                    .filter(tp => tp.type !== 'orientation')
                    .map(tp => (
                      <div style={{marginRight: '10px'}}>
                        <Checkbox
                          label={tp.header}
                          checked={this.state.selectedPhasesMap[tp.sequence]}
                          onChange={e => this.updateSelectedPhases(tp.sequence, e.target.checked)}
                        />
                      </div>
                    ))}
                </div>
                <div className="selected-users-header">Displaying report for users:</div>

                {this.state.reportAnalytics.map(({oitGuid, user}) => (
                  <Fragment>

                    <div key={oitGuid + 'remove'} className="selected-user">
                      {this.getOit(oitGuid).getFullName()}
                      <button className="button danger small" onClick={() => this.removeOitReport(oitGuid)}>
                        <i className="fa fa-trash-o mr-2"/>
                        Remove
                      </button>
                    </div>
                  </Fragment>
                ))}
              </div>
            ) : null}

          </div>

          {this.state.reportAnalytics.length > 0 && this.state.shownReports.statistics && (
            <OitRatingStatistics
              oits={this.selectedOits}
              selectedQuestions={this.state.selectedQuestionIds}
              selectedPhasesMap={this.state.selectedPhasesMap}
              onRemove={() => this.onReportTypeChange('statistics', false)}
            />
          )}
          {this.state.reportAnalytics.length > 0 && this.state.shownReports.log && (
            <LogAnalytics
              reportAnalytics={this.state.reportAnalytics}
              selectedPhasesMap={this.state.selectedPhasesMap}
            />
          )}
          {this.state.reportAnalytics.length > 0 && this.state.shownReports.analytics && (
            <AnalyticsReport
              isSelf={this.props.userContext.hasScope('oit')}
              reportAnalytics={this.state.reportAnalytics}
              filteredQuestions={this.filteredQuestions()}
              departmentSettings={this.props.departmentSettings}
              reportType={this.state.selectedReport}
              oitRemoved={this.onOitRemoved.bind(this)}
              reportClick={this.onReportClick.bind(this)}
              selectedPhasesMap={this.state.selectedPhasesMap}
            />
          )}

          <Modal
            title="Choose Observations"
            isOpen={this.state.showQuestionsModal}
            onClose={(e) => this.closeQuestionsModal(e)}
            size="sm"
          >
            <div className="questions-container">
              <div className="select-all">
                <div className="btn-container">
                  <button className="button secondary" onClick={() => this.selectAllQuestions(true)}>
                    Select All
                  </button>
                </div>

                <div className="btn-container right">
                  <button className="button secondary" onClick={() => this.deselectAllQuestions(true)}>
                    Deselect All
                  </button>
                </div>
              </div>

              {this.state.reportAnalytics.length > 0 && this.getAllQuestions().map(question => (
                <Checkbox
                  key={question}
                  checked={this.state.selectedQuestions[question]}
                  label={question}
                  onChange={(e) => {
                    this.onQuestionChange(e.target.checked, question)
                  }}
                />
              ))}
            </div>
          </Modal>
          <Modal
            title="Choose form types to display"
            isOpen={this.state.showFormTypeModal}
            onClose={(e) => this.closeFormTypeModal(e)}
            size="sm"
          >
            <div className="p-3">
              {this.currentForms.map(form => (
                <Checkbox
                  key={form.type}
                  checked={this.isFormTypeChecked(form)}
                  label={form.name}
                  onChange={(e) => {
                    this.onFormTypeSelectChange(e.target.checked, form)
                  }}
                />
              ))}
              <div>
                <button className="button primary mt-3" onClick={() => this.applyChanges()}>
                  Apply changes
                </button>
              </div>
            </div>
          </Modal>
        </div>
        <Modal
          isOpen={!!this.props.viewingReport}
          onClose={() => this.props.setIsViewingReport(null)}
          title={this.props.viewingReport && this.props.viewingReport.formName}
        >
          <ReportView report={this.props.viewingReport}/>
        </Modal>
      </LoadingOverlay>
    );
  }
}

function mapStateToProps(state) {
  return {
    oits: state.oits.list,
    viewingReport: state.reports.viewingReport,
    departmentSettings: state.departmentSettings.settings,
    canViewCritiqueForms: departmentSettingsSelectors.canViewCritiqueForms(state),
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    forms: state.forms.list,
    userContext: state.common.userContext,
    myTrainingProgram: state.myTrainingProgram,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadOitsContainer: (scope, status) => {
      return dispatch(oitsActionCreators.loadOitsContainer(scope, status));
    },
    setIsViewingReport: (report) => {
      return dispatch(reportsActionCreators.setIsViewingReport(report));
    },
    loadMyTrainingProgram: () => {
      return dispatch(myTrainingProgramActionCreators.loadMyTrainingProgram());
    },
  }
}


export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(OitAnalytics));
